export default __webpack_public_path__ + "static/media/Sycamore Icons-10.f1da03ab.svg";